import { render } from "./singleSet.vue?vue&type=template&id=015df113&scoped=true"
import script from "./singleSet.vue?vue&type=script&lang=js"
export * from "./singleSet.vue?vue&type=script&lang=js"

import "./singleSet.vue?vue&type=style&index=0&id=015df113&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015df113"]])

export default __exports__